<template>
<div id="secure">

    <NewTopMenu />
    <div class="container">
        <div class="columns">
            <div class="column is-3"><button class="button is-medium is-fullwidth is-primary" v-on:click="goManageClasses()">Classes/Departments &amp; Users</button></div>
            <div class="column is-3"><button class="button is-medium is-fullwidth" v-on:click="goManageTeachers()">Teachers/Supervisors</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth" v-on:click="goManageBehaviors()">Items</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth" v-on:click="goManageNotifications()">Notifications</button></div>
            <div class="column is-2"><button class="button is-medium is-fullwidth" v-on:click="goManageGroups()">Groups</button></div>
            <!-- <div class="column is-2"><button class="button is-medium is-fullwidth" v-on:click="goManageBadges()">Badges</button></div> -->
        </div>
        
        <nav class="breadcrumb" aria-label="breadcrumbs">
            <ul>
                <li>
                    <a v-on:click="goManageClasses()">Classes/Departments</a>
                </li>
                <li>
                    <a href="#">{{ className }}</a>
                </li>
                <li class="is-active">
                    <a href="#" aria-current="page">Students/Users</a>
                </li>
            </ul>
        </nav>
        <b-message title="What's Next?" type="is-success" aria-close-label="Close message" class="notification-tutorial">
            Already add students? Next, <a v-on:click="goManageQR()">generate their QR Tag here</a>.
        </b-message>

        <div class="columns">
            <div class="column is-12">
                <div class="card">
                    <loading :active.sync="isLoading1" 
                        :can-cancel="false" 
                        :is-full-page="false">
                    </loading>
                    <div class="card-header">
                        <p class="card-header-title">Transfer Whole Class/Department</p>
                    </div>
                </div>
                <div class="columns" style="margin: 2px; background-color: #fff;">
                    <div class="column one-half"><multiselect v-model="selectedClassToTransferWholeClass" :options="classListExceptCurrentClass" :close-on-select="true" :multiple="false" label="name" track-by="name" placeholder="Transfer to"></multiselect></div>
                    <div class="column one-half"><button class='button is-info' v-on:click="transferWholeClass()">Transfer Whole Class/Department</button></div>
                </div>
                <br />

                <div class="card">
                    <loading :active.sync="isLoading2" 
                        :can-cancel="false" 
                        :is-full-page="false">
                    </loading>
                    <div class="card-header">
                        <p class="card-header-title">Transfer by Students/Individual</p>
                    </div>
                </div>                
                <div class="columns" style="margin: 2px; padding: 10px; background-color: #fff;">
                    <multiselect v-model="selectedStudentsForTransfer" :options="studentListForTransfer" :close-on-select="false" :multiple="true" :hide-selected="true" label="name" track-by="name" placeholder="Select students/users to transfer"></multiselect>
                </div>
                <div class="columns" style="margin: 2px; background-color: #fff;">
                    <div class="column one-half"><multiselect v-model="selectedClassToTransfer" :options="classListToTransfer" :close-on-select="true" :multiple="false" label="name" track-by="name" placeholder="Transfer to"></multiselect></div>
                    <div class="column one-half"><button class='button is-info' v-on:click="transferStudents()">Transfer Now</button></div>
                </div>
                <br />

                <div class="card">
                    <loading :active.sync="isLoading3" 
                        :can-cancel="false" 
                        :is-full-page="false">
                    </loading>
                    <div class="card-header">
                        <p class="card-header-title">Students/Users</p>
                        <a class="button is-primary" v-on:click="importStudentForm()" style="margin: 5px;" v-show="!importStudent">Import from Excel</a>
                        <a class="button is-warning" v-on:click="closeImportStudentForm()" style="margin: 5px;" v-show="importStudent">Close import</a>
                        <a class="button is-primary" v-on:click="addStudentForm()" style="margin: 5px;" v-show="!addStudent">Add A Student/User</a>
                        <a class="button is-warning" v-on:click="closeAddStudentForm()" style="margin: 5px;" v-show="addStudent">Close Section</a>
                    </div>
                    <div class="card-content">

                        <div class="content" v-show="addStudent">                                    
                            <add-students :kelasID="kelasID"></add-students>
                        </div>

                        <div class="content" v-show="importStudent">                                    
                            <import-students :kelasID="kelasID"></import-students>
                        </div>

                        <div class="content">
                            <div class="columns bottom-border">
                                <div class="column">Students</div>
                                <div class="column is-2">&nbsp;</div>
                            </div>
                            <student-list v-bind:studentList="studentList" :kelasID="kelasID" :className="className"></student-list>
                        </div>
                    </div>
                </div>
                <br />
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NewTopMenu from "./../../NewTopMenu";
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'
import Multiselect from 'vue-multiselect'
import ImportStudents from './ImportStudents';
import AddStudents from './AddStudents';
import StudentList from './StudentList';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import "../../public/style.scss";

export default {
    name: "ManageTeachersHome",
    components: {
        NewTopMenu,
        Loading,
        ImportStudents,
        AddStudents,
        StudentList,
        Multiselect
    },
    data() {
        return {
            kelasID: "",
            className: "",
            studentList: [],
            studentListForTransfer: [{
                _id: '',
                name: ''
            }],
            classListToTransfer: [{
                _id: '',
                name: ''
            }],
            classListExceptCurrentClass: [{
                _id: '',
                name: ''
            }],
            input: { },
            isLoading1: false,
            isLoading2: false,
            isLoading3: false,
            isEditing: false,
            selectedStudentsForTransfer: [],
            selectedClassToTransfer: '',
            selectedClassToTransferWholeClass: '',
            addStudent: false,    
            importStudent: false,    
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
        console.log("before mount hoho");
        this.getStudentsInThisClass()
        this.getClassList()
        this.getAllStudents()
    },
    methods: {        
        transferWholeClass(){
            if (this.selectedClassToTransferWholeClass.length < 2){
                this.$swal({
                    type: "error",
                    title: 'Please select the class you want to transfer the whole students to',
                })
                return false;
            }

            let self = this;
            this.$swal({
                title: "Are you sure?",
                text: "ALL STUDENTS inside this class will be transferred to the new class. Are you sure?",
                showCancelButton: true,
                confirmButtonText: 'Yes, transfer WHOLE CLASS NOW',
                cancelButtonText: 'No, cancel',
                showCloseButton: true
            }).then((result) => {
                if (result.value){
                    self.isLoading1 = true;

                    axios.defaults.responseType = 'json'                        
                    axios.post(process.env.NEW_ENDPOINT + '/students/transfer/', {
                        token: localStorage.getItem('jwtTokenV2'),
                        email: localStorage.getItem('email'),
                        action: 'wholeClass',
                        currentKelasID: self.kelasID,
                        selectedKelasIDToTransfer: self.selectedClassToTransferWholeClass._id
                    })
                    .then(response => {
                        self.isLoading1 = false;
                        if (response.data.success == false) {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            self.getStudentsInThisClass();
                            Toast.open({
                                color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                message: response.data.msg,
                                type: 'is-success',
                                duration: 3000
                            })
                            this.selectedClassToTransferWholeClass = "";
                        }
                    })
                    .catch(e => {
                        self.isLoading1 = false;
                        console.log(e.response)
                        if (e.response.status === 401) {                            
                            Toast.open({
                                message: "Unauthorized access. Please re-login.",
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                message: 'Error: ' + e.response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        }
                    })
                }
            })
        },        
        transferStudents(){
            if (this.selectedStudentsForTransfer.length < 1){
                this.$swal({
                    type: "error",
                    title: 'Please select the students you want to transfer',
                })
                return false;
            }
            if (this.selectedClassToTransfer.length < 2){
                this.$swal({
                    type: "error",
                    title: 'Please select the class you want to transfer the students to',
                })
                return false;
            }

            let self = this;
            this.$swal({
                title: "Are you sure?",
                text: "Selected students above will be transferred to the new class. Continue?",
                showCancelButton: true,
                confirmButtonText: 'Yes, transfer',
                cancelButtonText: 'No, cancel',
                showCloseButton: true
            }).then((result) => {
                if (result.value){

                    
                    self.isLoading2 = true;

                    axios.defaults.responseType = 'json'
                    axios.post(process.env.NEW_ENDPOINT + '/students/transfer/', {
                        token: localStorage.getItem('jwtTokenV2'),
                        email: localStorage.getItem('email'),
                        action: 'selectedStudents',
                        selectedStudentsForTransfer: self.selectedStudentsForTransfer,
                        selectedKelasIDToTransfer: self.selectedClassToTransfer._id
                    })
                    .then(response => {
                        self.isLoading2 = false;
                        if (response.data.success == false) {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            self.getStudentsInThisClass();
                            Toast.open({
                                color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                message: response.data.msg,
                                type: 'is-success',
                                duration: 3000
                            })
                            this.selectedStudentsForTransfer = "";
                            this.selectedClassToTransfer = "";
                        }
                    })
                    .catch(e => {
                        self.isLoading2 = false;
                        console.log(e.response)
                        if (e.response.status === 401) {                            
                            Toast.open({
                                message: "Unauthorized access. Please re-login.",
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        } else {
                            Toast.open({
                                message: 'Error: ' + e.response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 5000
                            })
                        }
                    })
                }
            })
        },
        getClassList(){
            let self = this;
            this.isLoading1 = true;

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/classes/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
            })
            .then(response => {
                self.classListToTransfer = []
                self.classListExceptCurrentClass = []
                for (var i = 0; i < response.data.kelasList.length; i++){
                    var obj = {};
                    obj["_id"] = response.data.kelasList[i]._id;
                    obj["name"] = response.data.kelasList[i].level + " " + response.data.kelasList[i].name;

                    //so that the current class doesn't appear in the drop down list
                    if (self.kelasID != response.data.kelasList[i]._id){
                        self.classListExceptCurrentClass.push(obj);
                    }
                    self.classListToTransfer.push(obj);
                }
                self.isLoading1 = false
            })
            .catch(e => {
                console.log(e)
                self.isLoading1 = false
            })
        },
        getAllStudents(){
            let self = this;
            self.isLoading2 = true;
            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/students/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                category: "school",
                categoryID: "-"
            })
            .then(response => {
                self.studentListForTransfer = []
                for (var i = 0; i < response.data.length; i++){
                    var obj = {};
                    obj["_id"] = response.data[i]._id;
                    if (response.data[i].kelasID){
                        obj["name"] = response.data[i].firstName + " " + response.data[i].lastName + " (" + response.data[i].kelasID.level + " "  + response.data[i].kelasID.name  + ")";
                    }else{
                        obj["name"] = response.data[i].firstName + " " + response.data[i].lastName + " (no class)";
                    }
                    self.studentListForTransfer.push(obj);
                }
                self.isLoading2 = false
            })
            .catch(e => {
                console.log(e)
                self.isLoading2 = false
            })
        },
        getStudentsInThisClass(){
            let self = this;
            self.isLoading3 = true;
            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/students/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                category: "class",
                categoryID: self.kelasID
            })
            .then(response => {
                // JSON responses are automatically parsed.
                self.studentList = response.data
                self.isLoading3 = false
            })
            .catch(e => {
                console.log(e)
                self.isLoading3 = false
            })
        },
        goManageClasses(){
            this.$router.push({
                name: "ManageClassesHome"
            });
        },
        goManageTeachers(){
            this.$router.push({
                name: "ManageTeachersHome"
            });
        },
        goManageBehaviors(){
            this.$router.push({
                name: "ManageBehaviorsHome"
            });
        },
        goManageNotifications(){
            this.$router.push({
                name: "ManageNotificationsHome"
            });
        },
        goManageGroups(){
            this.$router.push({
                name: "ManageGroupsHome"
            });
        },
        goManageBadges(){
            this.$router.push({
                name: "ManageBadgesHome"
            });
        },
        goManageQR() {
            this.$router.push({
                name: "ManageQR"
            });
        },
        editData(){
            this.isEditing = true;
        },
        addStudentForm(){
            this.addStudent = true;
        },
        importStudentForm(){
            this.importStudent = true;
        },
        closeAddStudentForm(){
            this.addStudent = false;
        },
        closeImportStudentForm(){
            this.importStudent = false;
        },
    },
    created() {
        this.kelasID = this.$store.getters.getClassesDashboardSingleID;

        if (this.kelasID.trim.length < 1){
            this.kelasID = localStorage.getItem('CLASSES_DASHBOARD_SINGLE_ID')
        }

        console.log("this.kelasID: " + this.kelasID)
        this.className = this.$store.getters.getClassesDashboardSingleName;

        if (this.className.trim.length < 1){
            this.className = localStorage.getItem('CLASSES_DASHBOARD_SINGLE_NAME')
        }
        console.log("this.className: " + this.className)
    },
    mounted(){
    },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.container{
    padding: 10px;
}
.box{
    border: 1px solid #ccc;
    width: 40% !important;
    margin: 4px;
    padding: 0px !important;
}
.active{
    border: 1px solid rgb(6, 50, 247);
}
</style>



// WEBPACK FOOTER //
// src/components/Manage/Students/Home.vue